import React, { useEffect, useState } from "react";
import "./index.less";
import VarianceStatusesTable from "./activityTypesTable";
import { useSelector } from "react-redux";

const VarianceStatuses = () => {
  const { user } = useSelector((state) => state.authReducer);
  const [canUpdate, setCanUpdate] = useState(false);

  useEffect(() => {
    if (user?.permissions?.variance_statuses?.add_edit) {
      setCanUpdate(true);
    }
  }, [user]);

  return (
    <div className="page-top-div">
      <span className="text-span">Variance Statuses</span>
      <VarianceStatusesTable canUpdate={canUpdate} />
    </div>
  );
};

export default VarianceStatuses;
